import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Marquee from './Marquee';
import { useApp } from '../../hooks/useApp';

const MainLayout = () => {
  const { showMarquee } = useApp();

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      {showMarquee && <Marquee />}
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;